import { useLazyGetUsersQuery } from "@/shared/services";

export const useResolveMentionSuggestions = () => {
  const { query: getUsers } = useLazyGetUsersQuery();
  const handleResolveMentionSuggestions = async ({
    text,
    versionCreatorId,
  }: {
    text: string;
    versionCreatorId: string | undefined;
  }) => {
    const users = await getUsers();
    const types = ["user", "creator lite"];

    const filtered = users.filter((user: any) => {
      const name = user.firstName.toLowerCase();
      const email = user.email.toLowerCase();
      const query = text.toLowerCase();

      const isTextMatch = name.includes(query) || email.includes(query);
      const isTypeMatch =
        !types.includes(user.type) || user._id === versionCreatorId;
      return isTextMatch && isTypeMatch;
    });
    return filtered.map(({ _id }: { _id: string }): string => _id);
  };
  return handleResolveMentionSuggestions;
};
